import { HotelSuggestion } from "~/application/types";
import { HotelSuggestionDTO } from "../dtos";

export const mapHotelSuggestionDTO = (dto: HotelSuggestionDTO): HotelSuggestion => ({
  source: dto.source,
  name: dto.name,
  address: dto.address ?? null,
  placeId: dto.place_id ?? null,
  googlePlaceId: dto.google_place_id ?? null,
  latitude: dto.latitude ?? null,
  longitude: dto.longitude ?? null,
  rating: dto.rating ?? null,
  score: dto.score ?? null,
  cached: dto.cached ?? false,
});

export const mapHotelSuggestionWithFallbackDTO = (
  suggestedHotel?: HotelSuggestionDTO | null,
  suggestion?: string,
): HotelSuggestion | undefined => {
  if (suggestedHotel) {
    return mapHotelSuggestionDTO(suggestedHotel);
  }

  if (suggestion) {
    return { name: suggestion, source: "custom" };
  }

  return undefined;
};

